import { render, staticRenderFns } from "./EnvironmentIndicator.vue?vue&type=template&id=523d1a4c"
import script from "./EnvironmentIndicator.vue?vue&type=script&lang=js"
export * from "./EnvironmentIndicator.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentIndicator.vue?vue&type=style&index=0&id=523d1a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports